import {
  IBaseDateChartDataRange,
  IBaseDateChartDataValue,
  ICombinedDateChartData,
  IDateChartData,
} from '@app/api/interfaces/chart-data/base-date-chart-data';

export function convertDateChartDataInArray<
  IChartDataValue extends IBaseDateChartDataValue,
  IChartDataRange extends IBaseDateChartDataRange = IBaseDateChartDataRange,
>(data: IDateChartData<IChartDataValue, IChartDataRange>): ICombinedDateChartData<IChartDataValue, IChartDataRange>[] {
  const modifiedData: ICombinedDateChartData<IChartDataValue, IChartDataRange>[] = [];
  data.ranges.forEach(({ values, ...baseData }) => {
    const chartDataRange: IChartDataRange = baseData as unknown as IChartDataRange;

    values.forEach(el =>
      modifiedData.push({ ...chartDataRange, ...el } as ICombinedDateChartData<IChartDataValue, IChartDataRange>)
    );
  });

  return modifiedData;
}
